import React from "react";
import { motion } from "framer-motion";

import imdustryImg from "../../../../assets/images/industries-hero.png";

const HeroSection = () => {
  return (
    <section className="bg-blue-50 py-12 mt-10">
      <div className="container mx-auto flex flex-col-reverse lg:flex-row lg:grid lg:grid-cols-2 gap-y-8 px-8 lg:px-12 items-center">
        {/* Text Content */}
        <div className="flex flex-col gap-y-4">
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-3xl font-bold text-blue-900"
          >
            AI-Powered Solutions to Your Industry.
            <br></br>GROW 10X FASTER, 
            <br></br>BETTER AND SMARTER!
          </motion.h3>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="text-gray-600 text-lg"
          >
            ​We understand. Growing a business is hard. We make it whole lot easier, more predictable, less stressful and more fun.
            <br></br> Skip the guesswork and together, let’s redefine what’s <br></br> 
            possible in your sector.
          </motion.p>
        </div>

        {/* Image Content */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="relative items-end"
        >
          <img
            src={imdustryImg}
            alt="AI Assistant Mockup"
            className="w-3/4 transition-transform duration-300 transform hover:scale-105"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
